import { makeSlotKey, parseSlotKey } from "../master/store/eventIdentity";

export function hasCalendarSlotInstructorMismatch(
   calendarSlotKey,
   instructorId,
) {
   const parsed = parseSlotKey(String(calendarSlotKey || "").trim());
   const instructor = String(instructorId ?? "").trim();
   if (!parsed || !instructor) return false;
   return String(parsed.instructorId || "").trim() !== instructor;
}

/**
 * Calendar grid slot key: "dayIndex|instructorId|HH:mm"
 * (NOT the websocket draft key "instructorId|ISO").
 */
export function resolveCalendarSlotKeyForCreate({
   calendarSlotKey = "",
   calendarDayIndex = null,
   instructorId = "",
   slotLabel = "",
} = {}) {
   const inst = String(instructorId ?? "").trim();
   const slot = String(slotLabel ?? "").trim();
   const preset = String(calendarSlotKey || "").trim();
   const parsedPreset = preset ? parseSlotKey(preset) : null;

   if (parsedPreset) {
      // Keep day + time from the calendar cell, but paint under the instructor
      // actually selected for create (preset may be stale after instructor change).
      const presetInst = String(parsedPreset.instructorId || "").trim();
      if (inst && presetInst && presetInst !== inst) {
         return makeSlotKey(parsedPreset.dayIndex, inst, parsedPreset.slotLabel);
      }
      return preset;
   }

   const day = Number(calendarDayIndex);
   if (Number.isFinite(day) && day >= 0 && inst && slot) {
      return makeSlotKey(day, inst, slot);
   }
   return "";
}
